<template>
  <div
    v-if="isShow"
    class="acceptors">
    <v-skeleton-loader
      v-if="loading"
      :boilerplate="false"
      class="flex flex-wrap"
      :tile="false"
      type="avatar, sentences"
      width="200px"/>
    <StatusChip
      v-else-if="!stages || !stages.length"
      :data-qa="`${dataQa}-status-chip`"
      :status="'Draft'"/>
    <sPopover
      v-else
      popper-class="menu acceptor-list"
      trigger="hover"
      width="auto">
      <div
        slot="reference">
        <PersonWithStatus
          :avatars="allAgreements.slice(0, 2)"
          :data-qa="`${dataQa}-person-with-status`"
          :status="mainStatus.status"
          :tender-id="item.tenderId"
          :users="onlyStatus ? [] : allAgreements.slice(0, 2)"
          :with_photo="!onlyStatus"
          :without-order="true"
          without_tooltip/>
      </div>
      <div class="pa-4 acceptors-list">
        <StageAgreement
          v-for="(stage, stageIndex) in stages"
          :key="`stage-${stageIndex}`"
          :stage="stage"
          @click-info="val => $emit('click-info', val)"/>
      </div>
    </sPopover>
  </div>
</template>
<script>
import StatusChip from 'components/common/elements/StatusChip.vue'
import StageAgreement from 'components/agreement/StageAgreement.vue'
import PersonWithStatus from 'components/common/blocks/PersonWithStatus.vue'

const sortBlocks = ['waiting', 'decline', 'success', 'queued', 'canceled']

/**
 * Выпадалка согласовантов для карточки и таблицы тендера на странице тендеров
 */
export default {
  name: 'ListOfAcceptorsStages',
  computed: {
    isShow() {
      return this.stages?.length// || (!this.loading && this.stages?.length)
    },
    allAgreements() {
      if (!this.stages?.length) {
        return []
      }
      return this.stages.map(i => i.agreements).flat(1)
    },
    mainStatus() {
      const result = {
        status: null,
        title: null,
      }
      if (!this.stages?.length) {
        return result
      }
      sortBlocks.forEach((state) => {
        if (result.status) {
          return
        }
        const item = this.allAgreements.find(i => i.status.toLowerCase() === state)
        if (item) {
          result.status = item.status
          result.title = 'item.status'
        }
      })
      return result
    }
  },
  props: {
    stages: {
      type: Array,
    },
    item: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
    onlyStatus: {
      type: Boolean,
    },
    dataQa: {
      type: String,
      default: 'list-of-acceptors'
    },
  },
  components: {
    StatusChip,
    StageAgreement,
    PersonWithStatus
  },
}
</script>
<style>
.acceptor-list {
  max-height: 60%;
  overflow: auto;
}
</style>
